import React, { useContext, useEffect, useRef, useState } from "react";
import blogFetch from "../../axios/config";
import {
  Col,
  Container,
  Row,
  InputGroup,
  Form,
  Button,
  Modal,
  Spinner,
  Badge,
} from "react-bootstrap";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import "./styles.css";
import Context from "../../context/Context";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";

export const PartsInDevelopment = () => {
  const { setCode, getFicha, setIndustryPartsTable } = useContext(Context);
  const navigate = useNavigate();

  const [partsInDevelopment, setPartsInDevelopment] = useState([]);
  const [searchPieces, setSearchPices] = useState("");
  const [obsMap, setObsMap] = useState({});
  const obsDebounceRef = useRef({});

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMaterial, setModalMaterial] = useState("");
  const [modalData, setModalData] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);

  const [colorFilter, setColorFilter] = useState("");
  const [rangeFilters, setRangeFilters] = useState({ qtd_Pecas: { min: "", max: "" } });

  const [filters, setFilters] = useState({
    hp: "",
    Dia_Programada: "",
    reviewDate: "",
    ordem_DtLiberacao: "",
    lote_Corte: "",
    setor_Concatenado: "",
    ordem_Serial: "",
    ordem_Part_Short: "",
    ordem_VehCod: "",
    ordem_VehDesc: "",
    subProduto_Desc: "",
    ordem_CodMaterial: "",
    pedido_Cliente: "",
    pedido_Codigo: "",
    allocatedSteel: "",
    steelStatus: "",
    pedido_Data: "",
  });

  const filterLabels = {
    hp: "HP",
    Dia_Programada: "Dia Prog.",
    reviewDate: "Dias Prod.",
    ordem_DtLiberacao: "Dias Lib.",
    lote_Corte: "Lote",
    setor_Concatenado: "Setor",
    ordem_Serial: "OP",
    ordem_Part_Short: "Peça",
    ordem_VehCod: "Cód.Veíc.",
    ordem_VehDesc: "Veículo",
    subProduto_Desc: "Produto",
    ordem_CodMaterial: "Material",
    pedido_Cliente: "Cliente",
    pedido_Codigo: "Código",
    allocatedSteel: "Aço Aloc.",
    steelStatus: "Status Aço",
    pedido_Data: "Data",
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split(".");
    return new Date(`${year}-${month}-${day}`);
  };

  const diasDesdeLiberacao = (data) => {
    if (!data) return "";
    const targetDate = new Date(data);
    if (isNaN(targetDate)) return "";
    return Math.floor((new Date() - targetDate) / (1000 * 60 * 60 * 24));
  };

  const diasProgramadas = (Data_Lote, Data_Sap) => {
    if (!Data_Lote && !Data_Sap) return " ";
    const d1 = Data_Lote ? new Date(Data_Lote) : new Date();
    const d2 = Data_Sap ? new Date(Data_Sap) : new Date();
    if (isNaN(d1) || isNaN(d2)) return " ";
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    const diff = Math.floor((d2 - d1) / (1000 * 60 * 60 * 24));
    if (diff > 31) return "+31";
    if (diff < -31) return "-31";
    return diff;
  };

  const backGroundHours = (dataCompromisso) => {
    if (!dataCompromisso) return "#8bf9a3";
    let parsedDate = dataCompromisso;
    if (typeof dataCompromisso === "string" && dataCompromisso.includes(".")) {
      const [day, month, year] = dataCompromisso.split(".");
      parsedDate = `${year}-${month}-${day}`;
    }
    const targetDate = new Date(parsedDate);
    if (isNaN(targetDate)) return "#8bf9a3";
    const diffDays = Math.ceil((targetDate - new Date()) / (1000 * 60 * 60 * 24));
    if (diffDays <= 7) return "#FF0000";
    if (diffDays <= 10) return "#FFFF00";
    return "#8bf9a3";
  };

  const handleFilterChange = (e, col) => setFilters({ ...filters, [col]: e.target.value });

  const handleRangeChange = (field, bound, val) =>
    setRangeFilters((p) => ({ ...p, [field]: { ...p[field], [bound]: val } }));

  const handleObsChange = (serial, val) => {
    setObsMap((p) => ({ ...p, [serial]: val }));
    if (obsDebounceRef.current[serial]) clearTimeout(obsDebounceRef.current[serial]);
    obsDebounceRef.current[serial] = setTimeout(async () => {
      try {
        await blogFetch.post("/SAGAViewPecasSetor/Observacao", { OEN_Ordem: serial, OEN_Observacao: val });
      } catch (e) {
        console.error("Erro ao salvar observação:", e);
      }
    }, 3000);
  };

  const handleDeleteObs = async (serial) => {
    try {
      await blogFetch.delete(`/SAGAViewPecasSetor/Observacao/${serial}`);
      setObsMap((p) => { const n = { ...p }; delete n[serial]; return n; });
    } catch (e) {
      console.error("Erro ao excluir observação:", e);
    }
  };

  const clearAllFilters = () => {
    setFilters(Object.fromEntries(Object.keys(filters).map((k) => [k, ""])));
    setRangeFilters({ qtd_Pecas: { min: "", max: "" } });
    setColorFilter("");
    setSearchPices("");
  };

  const uniqueValues = (column) => {
    if (column === "reviewDate") {
      const vals = partsInDevelopment
        .map((i) => diasDesdeLiberacao(i.reviewDate))
        .filter((v) => v !== "" && v != null);
      return [...new Set(vals)].sort((a, b) => a - b);
    }
    if (column === "Dia_Programada") {
      const vals = partsInDevelopment
        .map((i) => diasProgramadas(i.reviewDate, i.ordem_DtLiberacao))
        .filter((v) => v !== "" && v != null && v !== " ");
      return [...new Set(vals)].sort((a, b) => a - b);
    }
    if (column === "ordem_DtLiberacao") {
      const vals = partsInDevelopment
        .map((i) => diasDesdeLiberacao(i.ordem_DtLiberacao))
        .filter((v) => v !== "" && v != null);
      return [...new Set(vals)].sort((a, b) => a - b);
    }
    if (column === "allocatedSteel") return ["Sim", "Não"];
    return [...new Set(partsInDevelopment.map((i) => i[column]).filter(Boolean))];
  };

  const filteredParts = partsInDevelopment
    .filter((item) => {
      const dropdownMatch = Object.keys(filters).every((key) => {
        if (!filters[key]) return true;
        if (key === "reviewDate")
          return diasDesdeLiberacao(item.reviewDate).toString() === filters[key];
        if (key === "Dia_Programada")
          return diasProgramadas(item.reviewDate, item.ordem_DtLiberacao).toString() === filters[key];
        if (key === "ordem_DtLiberacao")
          return diasDesdeLiberacao(item.ordem_DtLiberacao).toString() === filters[key];
        if (key === "allocatedSteel")
          return (item.allocatedSteel ? "Sim" : "Não") === filters[key];
        return item[key]?.toString() === filters[key];
      });

      const colorMatch = !colorFilter || backGroundHours(item.pedido_Data) === colorFilter;

      const qtd = parseFloat(item.qtd_Pecas);
      const minQtd = rangeFilters.qtd_Pecas.min !== "" ? parseFloat(rangeFilters.qtd_Pecas.min) : null;
      const maxQtd = rangeFilters.qtd_Pecas.max !== "" ? parseFloat(rangeFilters.qtd_Pecas.max) : null;
      const qtdMatch =
        (minQtd === null || (!isNaN(qtd) && qtd >= minQtd)) &&
        (maxQtd === null || (!isNaN(qtd) && qtd <= maxQtd));

      const s = searchPieces.toLowerCase();
      const searchMatch =
        !searchPieces ||
        item.hp?.toString().toLowerCase().includes(s) ||
        item.lote_Corte?.toString().toLowerCase().includes(s) ||
        item.setor_Concatenado?.toLowerCase().includes(s) ||
        item.ordem_Serial?.toString().toLowerCase().includes(s) ||
        item.ordem_Part_Short?.toLowerCase().includes(s) ||
        item.ordem_VehDesc?.toLowerCase().includes(s) ||
        item.subProduto_Desc?.toLowerCase().includes(s) ||
        item.ordem_CodMaterial?.toLowerCase().includes(s) ||
        item.pedido_Cliente?.toLowerCase().includes(s) ||
        item.pedido_Codigo?.toString().toLowerCase().includes(s) ||
        item.pedido_Data?.toLowerCase().includes(s);

      return dropdownMatch && colorMatch && qtdMatch && searchMatch;
    })
    .sort((a, b) => parseDate(a.pedido_Data) - parseDate(b.pedido_Data));

  useEffect(() => { GetPartsInDevelopment(); }, []);

  const GetPartsInDevelopment = async () => {
    try {
      const { data } = await blogFetch.get("/SAGAViewPecasSetor/pecaDev");
      setPartsInDevelopment(data);

      const { data: obsData } = await blogFetch.get("/SAGAViewPecasSetor/Observacao");
      const map = {};
      obsData.forEach((item) => {
        const ordem = item.oeN_Ordem;
        if (ordem && !map[ordem]) map[ordem] = item.oeN_Observacao;
      });
      setObsMap(map);
    } catch (e) {
      console.error(e);
    }
  };

  const openMaterialModal = async (material) => {
    if (!material) return;
    setModalMaterial(material);
    setModalData([]);
    setModalLoading(true);
    setModalOpen(true);
    try {
      const { data } = await blogFetch.get(`SAGAViewPecasSetor/HistoricoPecasDev/${material}`);
      setModalData(data);
    } catch (e) {
      console.error(e);
    } finally {
      setModalLoading(false);
    }
  };

  const handleclick = async (serial) => {
    setIndustryPartsTable(true);
    const data = await getFicha(serial);
    setCode(data);
    navigate("/Dashboard");
  };

  const totalQtd = filteredParts.reduce((acc, i) => acc + (parseFloat(i.qtd_Pecas) || 0), 0);
  const countRed = filteredParts.filter((i) => backGroundHours(i.pedido_Data) === "#FF0000").length;
  const countYellow = filteredParts.filter((i) => backGroundHours(i.pedido_Data) === "#FFFF00").length;
  const countGreen = filteredParts.filter((i) => backGroundHours(i.pedido_Data) === "#8bf9a3").length;

  const exportToExcel = () => {
    if (filteredParts.length === 0) return;

    const rows = filteredParts.map((item) => ({
      HP: item.hp || 0,
      "Dia Prog.": diasProgramadas(item.reviewDate, item.ordem_DtLiberacao),
      "Dias Prod.": diasDesdeLiberacao(item.reviewDate),
      "Dias Lib.": diasDesdeLiberacao(item.ordem_DtLiberacao),
      Lote: item.lote_Corte,
      Setor: item.setor_Concatenado,
      OP: item.ordem_Serial,
      Peça: item.ordem_Part_Short,
      "Cód.Veíc.": item.ordem_VehCod,
      Veículo: item.ordem_VehDesc,
      Produto: item.subProduto_Desc,
      Material: item.ordem_CodMaterial,
      Cliente: item.pedido_Cliente,
      Código: item.pedido_Codigo,
      "Aço Aloc.": item.allocatedSteel ? "Sim" : "Não",
      "Status Aço": item.steelStatus ?? "",
      Data: item.pedido_Data,
      OBS: obsMap[item.ordem_Serial] ?? "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    worksheet["!cols"] = [];
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let maxLength = 10;
      for (let R = range.s.r; R <= range.e.r; ++R) {
        const cell = worksheet[XLSX.utils.encode_cell({ c: C, r: R })];
        if (cell && cell.v != null) {
          const length = cell.v.toString().length;
          if (length > maxLength) maxLength = length;
        }
      }
      worksheet["!cols"][C] = { wch: maxLength + 2 };
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Peças em Desenvolvimento");

    const today = new Date().toLocaleDateString("pt-BR").replace(/\//g, "-");
    XLSX.writeFile(workbook, `Pecas_em_Desenvolvimento_${today}.xlsx`);
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <Container fluid className="app_body px-2">
        <Row>
          <Col>
            <div className="d-flex pb-2 align-items-end justify-content-between flex-wrap gap-2">

              <div style={{ minWidth: 230 }}>
                <InputGroup size="sm">
                  <Form.Control
                    placeholder="Buscar Peça / OP"
                    value={searchPieces}
                    onChange={({ target }) => setSearchPices(target.value)}
                  />
                  <Button variant="primary" size="sm">Buscar</Button>
                </InputGroup>
              </div>

              <div className="text-center">
                <h5 className="title_tables mb-0 fw-bold">PEÇAS EM DESENVOLVIMENTO</h5>
                <div className="d-flex gap-2 justify-content-center mt-1 flex-wrap align-items-center">
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 4,
                    background: "#1e293b", color: "#f1f5f9",
                    borderRadius: 8, padding: "2px 10px", fontSize: "0.82rem", fontWeight: 600,
                  }}>
                    OPs: <span style={{ fontSize: "1rem", fontWeight: 700 }}>{filteredParts.length}</span>
                  </span>
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 3,
                    background: "#fee2e2", color: "#b91c1c",
                    borderRadius: 8, padding: "2px 9px", fontSize: "0.82rem", fontWeight: 600,
                  }}>🔴 {countRed}</span>
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 3,
                    background: "#fef9c3", color: "#a16207",
                    borderRadius: 8, padding: "2px 9px", fontSize: "0.82rem", fontWeight: 600,
                  }}>🟡 {countYellow}</span>
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 3,
                    background: "#dcfce7", color: "#166534",
                    borderRadius: 8, padding: "2px 9px", fontSize: "0.82rem", fontWeight: 600,
                  }}>🟢 {countGreen}</span>
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 4,
                    background: "#ede9fe", color: "#5b21b6",
                    borderRadius: 8, padding: "2px 10px", fontSize: "0.82rem", fontWeight: 600,
                    border: "1px solid #c4b5fd",
                  }}>
                    Qtd: <span style={{ fontSize: "1.1rem", fontWeight: 800 }}>{totalQtd}</span>
                  </span>
                </div>
              </div>

              <div className="d-flex gap-2 flex-wrap align-items-end">
                <div>
                  <small className="fw-semibold d-block mb-1">Prioridade (Data)</small>
                  <div className="d-flex gap-1">
                    {[
                      { color: "#FF0000", label: "🔴", title: "Urgente ≤7d" },
                      { color: "#FFFF00", label: "🟡", title: "Atenção 8–10d" },
                      { color: "#8bf9a3", label: "🟢", title: "Normal >10d" },
                    ].map(({ color, label, title }) => (
                      <Button
                        key={color}
                        size="sm"
                        title={title}
                        variant={colorFilter === color ? "dark" : "outline-secondary"}
                        style={{
                          backgroundColor: colorFilter === color ? color : undefined,
                          borderColor: color,
                          minWidth: 36,
                          fontWeight: colorFilter === color ? 700 : 400,
                        }}
                        onClick={() => setColorFilter((p) => (p === color ? "" : color))}
                      >
                        {label}
                      </Button>
                    ))}
                  </div>
                </div>
                <Button variant="outline-secondary" size="sm" onClick={clearAllFilters}>
                  Limpar
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  onClick={exportToExcel}
                  disabled={filteredParts.length === 0}
                  title="Exportar a lista atual (com filtros aplicados) para Excel"
                >
                  Exportar Excel
                </Button>
              </div>
            </div>

            <div style={{ overflowX: "auto", width: "100%" }}>
              <table
                className="tableFixHead table table-hover align-middle text-center shadow-sm mb-0"
                style={{ width: "100%", minWidth: 1150, tableLayout: "fixed", fontSize: "0.88rem" }}
              >
                <colgroup>
                  <col style={{ width: "3.5%" }} />
                  <col style={{ width: "3.5%" }} />
                  <col style={{ width: "3.5%" }} />
                  <col style={{ width: "3.5%" }} />
                  <col style={{ width: "4.5%" }} />
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "4.5%" }} />
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "4.5%" }} />
                  <col style={{ width: "8%" }} />
                  <col style={{ width: "7%" }} />
                  <col style={{ width: "6%" }} />
                  <col style={{ width: "7%" }} />
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "4.5%" }} />
                  <col style={{ width: "6%" }} />
                  <col style={{ width: "5%" }} />
                  <col style={{ width: "15%" }} />
                </colgroup>

                <thead>
                  <tr className="filter-row">
                    {Object.keys(filters).map((col) => (
                      <th key={col} style={{ padding: "3px 4px" }}>
                        <Form.Select
                          size="sm"
                          value={filters[col]}
                          onChange={(e) => handleFilterChange(e, col)}
                          style={{ fontSize: "0.75rem", padding: "2px 4px" }}
                        >
                          <option value="">{filterLabels[col]}</option>
                          {uniqueValues(col).map((val) => (
                            <option key={val} value={val}>{val}</option>
                          ))}
                        </Form.Select>
                      </th>
                    ))}
                    <th style={{ padding: "3px 4px" }}><small className="text-muted">OBS</small></th>
                  </tr>

                  <tr className="label-row">
                    {Object.values(filterLabels).map((label, idx) => (
                      <th key={idx} style={{ padding: "6px 5px", fontSize: "0.78rem" }}>
                        {label}
                      </th>
                    ))}
                    <th style={{ padding: "6px 5px", fontSize: "0.78rem" }}>OBS</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredParts.map((item, idx) => (
                    <tr key={idx}>
                      <td style={{ backgroundColor: item.cor_HP, color: item.cor_HP === "#000" ? "#FFF" : "#000", padding: "6px 5px" }}>
                        {item.hp || 0}
                      </td>
                      <td style={{ padding: "6px 5px" }}>
                        {diasProgramadas(item.reviewDate, item.ordem_DtLiberacao)}
                      </td>
                      <td style={{ padding: "6px 5px" }}>
                        {diasDesdeLiberacao(item.reviewDate)}
                      </td>
                      <td style={{ padding: "6px 5px" }}>
                        {diasDesdeLiberacao(item.ordem_DtLiberacao)}
                      </td>
                      <td style={{ padding: "6px 5px" }}>{item.lote_Corte}</td>
                      <td style={{ padding: "6px 5px" }}>{item.setor_Concatenado}</td>
                      <td
                        className="text-primary fw-bold"
                        style={{ cursor: "pointer", padding: "3px 2px" }}
                        onClick={() => handleclick(item.ordem_Serial)}
                      >
                        {item.ordem_Serial}
                      </td>
                      <td style={{ padding: "6px 5px" }}>{item.ordem_Part_Short}</td>
                      <td style={{ padding: "6px 5px" }}>{item.ordem_VehCod}</td>
                      <td style={{ padding: "3px 2px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 0 }} title={item.ordem_VehDesc}>
                        {item.ordem_VehDesc}
                      </td>
                      <td style={{ padding: "3px 2px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 0 }} title={item.subProduto_Desc}>
                        {item.subProduto_Desc}
                      </td>
                      <td style={{ padding: "6px 5px" }}>
                        <span
                          onClick={() => openMaterialModal(item.ordem_CodMaterial)}
                          title="Ver histórico deste material"
                          style={{
                            cursor: "pointer",
                            color: "#0d6efd",
                            fontWeight: 600,
                            textDecoration: "underline dotted",
                            textUnderlineOffset: 3,
                          }}
                        >
                          {item.ordem_CodMaterial}
                        </span>
                      </td>
                      <td style={{ padding: "3px 2px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 0 }} title={item.pedido_Cliente}>
                        {item.pedido_Cliente}
                      </td>
                      <td style={{ padding: "7px 7px" }}>{item.pedido_Codigo}</td>
                      <td style={{ padding: "7px 7px" }}>
                        <span style={{
                          display: "inline-block",
                          padding: "1px 6px",
                          borderRadius: 10,
                          fontSize: "0.7rem",
                          fontWeight: 600,
                          backgroundColor: item.allocatedSteel ? "#d4edda" : "#f8d7da",
                          color: item.allocatedSteel ? "#155724" : "#721c24",
                        }}>
                          {item.allocatedSteel ? "Sim" : "Não"}
                        </span>
                      </td>
                      <td style={{ padding: "6px 5px" }}>{item.steelStatus ?? "—"}</td>
                      <td style={{ backgroundColor: backGroundHours(item.pedido_Data), padding: "3px 2px", fontWeight: 600 }}>
                        {item.pedido_Data}
                      </td>
                      <td style={{ padding: "2px" }}>
                        <div style={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
                          <Form.Control
                            as="textarea"
                            rows={1}
                            size="sm"
                            placeholder="Obs..."
                            value={obsMap[item.ordem_Serial] ?? ""}
                            onChange={(e) => handleObsChange(item.ordem_Serial, e.target.value)}
                            style={{ resize: "vertical", fontSize: "0.75rem", minHeight: 28, padding: "2px 4px" }}
                          />
                          {obsMap[item.ordem_Serial] && (
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Excluir observação"
                              onClick={() => handleDeleteObs(item.ordem_Serial)}
                              style={{ padding: "2px 6px", fontSize: "0.7rem", minWidth: 24 }}
                            >
                              ✕
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </Container>

      <Modal show={modalOpen} onHide={() => setModalOpen(false)} centered size="lg">
        <Modal.Header closeButton style={{ background: "#1e293b", color: "#f8fafc", borderBottom: "none" }}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            Histórico do Material&nbsp;
            <Badge bg="secondary" style={{ fontSize: "0.85rem", letterSpacing: 1 }}>
              {modalMaterial}
            </Badge>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "16px 20px", minHeight: 200 }}>
          {modalLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: 150 }}>
              <Spinner animation="border" variant="primary" />
            </div>
          ) : modalData.length === 0 ? (
            <div className="text-center text-muted py-5">
              <div style={{ fontSize: "2rem" }}>📭</div>
              <div className="mt-2">Nenhum registro encontrado para este material.</div>
            </div>
          ) : (
            <>
              <p className="text-muted mb-2" style={{ fontSize: "0.8rem" }}>
                {modalData.length} ordem(ns) encontrada(s)
              </p>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85rem" }}>
                <thead>
                  <tr style={{ background: "#f1f5f9", borderBottom: "2px solid #e2e8f0" }}>
                    <th style={thStyle}>#</th>
                    <th style={thStyle}>Ordem (OP)</th>
                    <th style={thStyle}>Último Setor Apontado</th>
                    <th style={thStyle}>Status Apontamento</th>
                  </tr>
                </thead>
                <tbody>
                  {modalData.map((row, i) => (
                    <tr
                      key={i}
                      style={{
                        borderBottom: "1px solid #e2e8f0",
                        background: i % 2 === 0 ? "#fff" : "#f8fafc",
                        transition: "background 0.15s",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#eff6ff")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = i % 2 === 0 ? "#fff" : "#f8fafc")}
                    >
                      <td style={tdStyle}>{i + 1}</td>
                      <td style={{ ...tdStyle, fontWeight: 700, color: "#1d4ed8" }}>
                        {row.ordem_Serial ?? row.Ordem_Serial ?? "—"}
                      </td>
                      <td style={tdStyle}>
                        {row.setor_Concatenado ?? row.setor_Concatenado ?? "—"}
                      </td>
                      <td style={tdStyle}>
                        {row.ordem_UltStatusApontado ?? row.ordem_UltStatusApontado ?? "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #e2e8f0" }}>
          <Button variant="outline-secondary" size="sm" onClick={() => setModalOpen(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const thStyle = {
  padding: "8px 12px",
  textAlign: "center",
  fontWeight: 600,
  color: "#475569",
  fontSize: "0.78rem",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
};

const tdStyle = {
  padding: "8px 12px",
  textAlign: "center",
  color: "#334155",
};
